export function ImportantNotice({
  children,
  type = 'info',
  label = 'Important',
}: {
  children: React.ReactNode
  type?: 'info' | 'warning'
  label?: string
}) {
  const bgClass = type === 'warning' ? 'bg-[#FCF2BD]' : 'bg-cf-sf-green-100'
  return (
    <div className={`${bgClass} rounded p-4 mb-4`}>
      <p className="text-cf-sf-grey-1000 font-semibold">{label}</p>
      <p className="text-cf-grey-700">{children}</p>
    </div>
  )
}
